import React from 'react';
import { ProgressModal } from '@doer/frontend-components/modal';

export interface SaveProgressState {
  step: string;
  percent: number;
}

interface SaveProgressModalProps {
  progress: SaveProgressState | null;
}

export const SaveProgressModal: React.FC<SaveProgressModalProps> = ({ progress }) => {
  const isDone = progress?.percent === 100;

  return (
    <ProgressModal
      open={progress !== null}
      title={isDone ? '¡Listo!' : 'Guardando creatividad'}
      subtitle={isDone ? 'Creatividad guardada en la librería' : progress?.step}
      percent={progress?.percent ?? 0}
      done={isDone}
    />
  );
};
